import { addFormatToken } from '../format-functions';
import { getSeconds } from '../utils/date-getters';
addFormatToken('s', ['ss', 2], null, function (date) {
    return getSeconds(date).toString(10);
});
//# sourceMappingURL=second.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/bs-moment/units/second.js
// module id = 761
// module chunks = 9